import type { CategoryDto } from '#Products/models/Pim/CategoryDto'

export const useCategories = async () => {
  const { support, store } = usePim()

  await support.loadCategories()

  const categories = computed(() => store.categories)

  const byIds = computed<Record<string, CategoryDto>>(
    () => categories.value?.allByIds || {},
  )
  const allRoot = computed(
    () =>
      categories.value?.rootIds?.map(id => byIds.value[id] as CategoryDto)
      || [],
  )
  const all = computed(() => categories.value?.allByIds)

  return {
    byIds,
    all,
    allRoot,
  }
}
